function handleMetafieldProductCards() {
  const productCards = document.querySelectorAll('.gdc-article__product-hero')
  const newParents = document.querySelectorAll('.gdc-article__product-hero--parent')

  productCards.forEach((card, i) =>{
    const parent = newParents[i]

    if (parent) {
      let imageDisplay = parent.dataset.imageDisplay
      let cardIndex = card.dataset.index
      card.style.display = 'flex'
      if (imageDisplay === 'left') card.style.flexDirection = 'row-reverse'
      newParents[cardIndex].appendChild(card)
    }
    
  })
}

window.addEventListener('load', () => {
  handleMetafieldProductCards()
})
